import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import {
  initializeMap,
  setMapviewExtent
} from '../../controller/esriMapController'
import './MapView.scss'
import CustomAppTour from '../CustomAppTour'

function MapViewContainer() {
  const mapViewRef = useRef(null)
  const { showCircularProgress, selectedFeature, mapLoaded, manualStreetMode } =
    useSelector((state) => state.appSlice)

  useEffect(() => {
    initializeMap(mapViewRef.current)
  }, [])

  useEffect(() => {
    if (selectedFeature && mapLoaded) {
      setMapviewExtent()
    }
  }, [selectedFeature, mapLoaded])

  return (
    <div id="mapview-container">
      <div id="mapview" ref={mapViewRef} />
      {showCircularProgress && (
        <CircularProgress
          sx={{
            position: 'absolute',
            top: '50%',
            zIndex: 100000,
            left: '50%'
          }}
        />
      )}
      {mapLoaded && <CustomAppTour />}
      {manualStreetMode && (
        <Backdrop sx={{ color: '#fff', zIndex: 100000 }} open={true} />
      )}
    </div>
  )
}

export default MapViewContainer
